export default __webpack_public_path__ + "static/upcity-ade6c0525931b29345c5ba43b6d57422.png";